import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

import Modal from "react-modal";
import html2pdf from "html2pdf.js";

const FarmerPurchaseListReport = () => {
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
      left: 30,
    },
    content: {
      top: "50%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px",
      minHeight: "500px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };
  
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/procurementwise");
  };

  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);

  const [marketDetailId, setMarketDetailId] = useState();
  const [marketDetailList, setMarketDetailList] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [farmActivityData, setFarmActivityData] = useState([]);
  const [farmActivityId, setFarmActivityId] = useState();

  const [plotData, setPlotData] = useState([]);

  const [plotId, setPlotId] = useState();

  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const loadCountData = (id) => {
    FillReport(id);
  };

  const FillReport = (employeeId, regionId) => {
    var d = new Date(selectedToDate);

    d.setDate(d.getDate() + 1);

    //console.log("d", d);
    var tdate = moment(d).format("DD/MM/YYYY");

    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    //var tdate=moment(selectedToDate).format("DD/MM/YYYY");

    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (marketDetailId > 0) {
      urlfilter = urlfilter + `&marketDetailId=${marketDetailId}`;
    }

    console.log("marketDetailId", marketDetailId);
    var url = `/api/farmerPurchaseReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        var emplist = data.output; //data.output.filter((item) => item.useCase == "Procurement");

        setEmployeeData(emplist);
      }
    );
  }, [getEmp]);

  const { sendRequest: getMarketDetail } = useHttp();

  const FillgetMarketDetail = (_warehouseId) => {
    getMarketDetail(
      {
        url: `/api/fillMarketDetailList/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${_warehouseId}`,
        method: "Get",
      },
      (data) => {
        setMarketDetailList(data);
        console.log("data", data);
      }
    );
  };

  useEffect(() => {
    FillgetMarketDetail(0);
  }, [getMarketDetail]);

  const { sendRequest: getplotDetails } = useHttp();

  const plotDetail = (empId) => {
    var urlfilter = "";

    if (empId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${empId}`;
    }

    getplotDetails(
      {
        url: `/api/plotDetails/?orgId=${localStorage.getItem(
          "orgId"
        )}${urlfilter} `,
      },
      (data) => {
        var plotlist = data; //data.output.filter((item) => item.useCase == "Procurement");

        setPlotData(plotlist);
      }
    );
  };

  useEffect(() => {
    plotDetail(0);
  }, [getplotDetails]);

  const fieldsToExport = [
    "farmerPurchaseDate",
    "farmerPurchaseNo",
    "employeeName",
    "marketDocNo",
    "farmerName",
    "fieldExecutive",
    "areaName",
    "totalQty",
    "unitAbbreviation",
    "totalAmount",
    "loanAmount",
    "advanceAmount",
    "balanceAmount",
  ];

  const customHeaders = [
    "Purchase Date",
    "Purchase No",
    "Employee",
    "Market Detail",
    "Farmer Name",
    "Field Executive",
    "Area",
    "Total Quantity",
    "Unit",
    "Total Amount",
    "Loan Amount ",
    "Advance Amount",
    "Balance Amount",
  ];

  const handleExportExcel = () => {
    const filename = "FarmerPurhaseList.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getDetailView } = useHttp();

  const viewPdf = (id) => {
    setPdfView(true);

    const Id = id;

    getDetailView(
      {
        url: `/api/farmerPurchaseDetail/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerPurchaseId=${Id}`,
      },
      (res) => {
        setPdfData(res);
        console.table(res);
        
      }
    );
  };
  
  const generatePDF = (docNo) => {
    const input = pdfContainerRef.current;

    const pdfName = docNo || "Farmer Purchase";

    html2pdf(input, {
      margin: 10,
      filename: `${pdfName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" },
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Farmer Purchase Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Warehouse Manager"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      plotDetail(userid);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"MarketDetail"}>{"Market Detail"}</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={marketDetailId}
                    onChange={(e) => {
                      var _marketDetailId = 0;
                      if (e.target.value != "--Select--")
                        _marketDetailId = e.target.value;

                      setMarketDetailId(_marketDetailId);
                    }}
                  >
                    <option>--Select--</option>
                    {marketDetailList &&
                      marketDetailList.map((x) => (
                        <option
                          key={x.marketDetailId}
                          user-id={x.marketDetailId}
                          value={x.marketDetailId}
                        >
                          {x.docNo}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    // ref={(el) => (frmRef.current["pdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>

              <div className="col-md-3"></div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "1.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th> Purchase Date </th>
                          <th> Purchase No</th>
                          <th> Employee</th>
                          <th> Market Detail </th>
                          <th> Farmer Name </th>
                          <th> Field Executive </th>
                          <th> Area</th>
                          <th> Total Quantity</th>
                          <th> Unit</th>
                          <th> Total Amount</th>
                          <th> Loan Amount </th>
                          <th> Advance Amount </th>
                          <th> Balance Amount </th>
                          <th>View</th>
                        </tr>
                      </thead>

                      {currentItems &&
                        currentItems.map((itm, i) => {
                          return (
                            <tr key={i} className="tablerowview">
                              <td> {itm.farmerPurchaseDate} </td>
                              <td> {itm.farmerPurchaseNo} </td>
                              <td>{itm.employeeName}</td>
                              <td> {itm.marketDocNo} </td>
                              <td> {itm.farmerName} </td>
                              <td> {itm.fieldExecutive} </td>
                              <td> {itm.areaName} </td>
                              <td> {itm.totalWeightQty} </td>
                              <td> {itm.unitAbbreviation} </td>
                              <td> {itm.totalAmount} </td>
                              <td> {itm.loanAmount} </td>
                              <td> {itm.advanceAmount} </td>
                              <td> {itm.balanceAmount} </td>
                              <td>
                                  <button
                                    className="btn"
                                    onClick={() => viewPdf(itm.farmerPurchaseId)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                            </tr>
                          );
                        })}
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
        {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          <div className="pdf-main-container ">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div className="pdf-container mx-3" ref={pdfContainerRef}>
              <br />
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                    
                      <div className="invoice p-3 mb-3">
              
                        <div className="row">
                          <div className="col-12">
                            <h4>
                              <img
                                src={`${process.env.REACT_APP_FILE_URL}${
                                  localStorage.getItem("organizationIcon")
                                }`}
                                width="50"
                                height="50"
                                alt=""
                              />
                             {"Farmer Purchase Detail"}
                            </h4>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* info row */}
                        <div className="row invoice-info">
                          <div className="col-sm-6 invoice-col">
                            From
                            <address>
                              <strong>
                                {localStorage.getItem("organizationName")}
                              </strong>
                              <br />
                              To
                              <strong>
                                <br />
                                {pdfData && pdfData.farmerName}(
                              </strong>
                              {pdfData && pdfData.identificationNo})
                              <br />
                              <b>Doc No ID:</b>{" "}
                              {pdfData && pdfData.farmerPurchaseNo}
                              <br />
                              <b>Crop :</b> {pdfData && pdfData.cropName}
                            </address>
                          </div>
                          {/* /.col */}

                          {/* /.col */}
                          <div className="col-sm-6 invoice-col">
                            <br />
                            <b>Date:</b> {pdfData && pdfData.farmerPurchaseDate}
                            <br />
                            <b>Field Officer :</b>{" "}
                            {pdfData && pdfData.employeeName}
                            <br />
                            <b>Warehouse:</b> {pdfData && pdfData.warehouseName}
                            <br />
                            <b>Market Details No:</b>{" "}
                            {pdfData && pdfData.marketDocNo} <br />
                            <b>Area Name:</b> {pdfData && pdfData.areaName}
                            <br />
                          </div>
                          <div className="col-sm-4 invoice-col"></div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        {/* Table row */}
                        <div className="row">
                          <div className="col-12 table-responsive">
                            <table className="table  table-bordered">
                              <thead style={{ background: "#F0E9EA" }}>
                                <tr>
                                  <th>Sr. No</th>
                                  <th>Bales Number</th>
                                  <th>Tag Serial No</th>

                                  <th>Purchase Grade</th>
                                  <th>Bales Weight(kg)</th>
                                  <th>Price/Kg</th>
                                  <th>Total Amount</th>
                                  {/* <th>Reclass Grade</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {pdfData.BalesDetail &&
                                  pdfData.BalesDetail.map((itm, i) => {
                                    return (
                                      <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{itm.balesNo}</td>
                                        <td>{itm.sellingTagSerialNo}</td>
                                        <td>{itm.purchaseGradeName}</td>
                                        <td>{itm.baleWeight}</td>
                                        <td>{itm.price}</td>
                                        <td>{itm.totalBalesAmount}</td>
                                        {/* <td>{itm.reClassGradeName}</td> */}
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                          {/* /.col */}
                        </div>
                        {/* /.row */}
                        <div className="row">
                          <div className="col-6">
                            <p className="text-muted well well-sm shadow-none">
                              Remark/Note:
                            </p>
                            <p> {pdfData && pdfData.remark}</p>
                            <hr />
                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              Name of Authorized Signatory:
                            </p>
                            <br />
                            <hr />

                            <p
                              className="text-muted well well-sm shadow-none"
                              style={{ marginTop: 10 }}
                            >
                              This is Computer Generated Document
                            </p>
                          </div>

                          <div className="col-6">
                            <div className="table-responsive">
                              <table className="table">
                                <tbody className="text-right">
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Quantity :
                                    </th>
                                    <td> {pdfData && pdfData.totalWeightQty} &nbsp;Kg</td>
                                  </tr>

                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Total Amount:
                                    </th>
                                    <td> {pdfData && pdfData.totalAmount}</td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "50%" }}>
                                      Advance Amount:
                                    </th>
                                    <td> {pdfData && pdfData.advanceAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Loan Amount</th>
                                    <td> {pdfData && pdfData.loanAmount}</td>
                                  </tr>
                                  <tr>
                                    <th>Balance Amount :</th>
                                    <td> {pdfData && pdfData.balanceAmount}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row no-print">
            <div className="col-12">
              <button
                type="button"
                className="btn btn-primary float-right generate-pdf-button"
                style={{ marginRight: 5 }}
                onClick={() => generatePDF(pdfData && pdfData.farmerPurchaseNo)}
              >
                <i className="fas fa-download" /> Generate PDF
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default FarmerPurchaseListReport;
